export const burgerNavButtonGroupTracking = (departmentName) => {
    window.dataLayer = window.dataLayer || [];
    const {
        page_path: pagePath
    } = App.Config.GaTrackingPage;

    window.dataLayer.push({
        event: 'menu_button_groups',
        department: departmentName,
        page_path: pagePath
    });
};
